import { SaleType } from 'app/dataTypes/dishes/saleType'

import styles from './DeletionWarning.scss'


type Props = {
  saleTypesToBeRemoved: Array<SaleType>
}

export const DeletionWarning = ({ saleTypesToBeRemoved }: Props) => {
  if (!saleTypesToBeRemoved.length) {
    return (
      <div>{'Произошла неизвестная ошибка. Нажмите «Отмена»'}</div>
    )
  }

  const numberOf = saleTypesToBeRemoved.length > 1 ? ` (${saleTypesToBeRemoved.length})` : ''

  return (
    <div className={styles.root}>
      <div className={styles.listTitle}>{`Будут удалены  следующие типы продукции${numberOf}: `}</div>
      <ul>
        {saleTypesToBeRemoved.map(saleType => (
          <li key={saleType.id}>{saleType.title}</li>
        ))}
      </ul>
    </div>
  )
}
